import FilterListingItem from './FilterListingItem';

export default FilterListingItem;
